module.exports = __webpack_public_path__ + "static/profile-e21f58a6ca368d2d1ef7030ddea6348d.png";